//app
import { app, PRODUCTION } from "../../../config/env";

function handleExperiments() {
  // Push experiments data to GTM
  const prodUA = "UA-46356044-1";
  const testUA = "UA-46356044-2";
  const propertyId = app.appEnv === PRODUCTION ? prodUA : testUA;

  let experiments = Object.prototype.hasOwnProperty.call(
    gaData[propertyId],
    "experiments"
  )
    ? gaData[propertyId].experiments
    : {};

  if (Object.keys(experiments).length > 0) {
    const totals = Object.keys(experiments).reduce(
      (reducer, key, index) =>
        index !== Object.keys(experiments).length - 1
          ? reducer + key + "." + experiments[key] + "/"
          : reducer + key + "." + experiments[key],
      ""
    );

    dataLayer.push({
      experiment_variation: totals,
    });

    localStorage.setItem("all_experiments", totals);
  } else {
    localStorage.removeItem("all_experiments");
  }
}

export default handleExperiments;
